/**
 * xelara-cart.js — cart drawer extras (client change list 6, 2026-09-23):
 * <xelara-cart-recommendations> fetches the xelara-cart-recommendations
 * section through the Section Rendering API; <xelara-cart-discount> applies
 * codes with /cart/update.js and re-renders the drawer.
 */
const drawerSectionHTML = (html, selector = '.drawer__inner') =>
  new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

function rerenderDrawer(sectionHtml) {
  const fresh = drawerSectionHTML(sectionHtml);
  const inner = document.querySelector('cart-drawer .drawer__inner');
  if (fresh && inner) inner.innerHTML = fresh.innerHTML;
}

class XelaraCartRecommendations extends HTMLElement {
  connectedCallback() {
    const id = this.dataset.productId;
    if (!id || !this.dataset.url) return;
    fetch(`${this.dataset.url}&product_id=${id}`)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const recs = doc.querySelector('[data-xel-cart-recs]');
        if (!recs || !recs.querySelector('[data-xel-recs-row]')) {
          this.remove();
          return;
        }
        this.innerHTML = recs.outerHTML;
        this.bindNav();
      })
      .catch(() => this.remove());
  }

  bindNav() {
    const row = this.querySelector('[data-xel-recs-row]');
    if (!row) return;
    const step = () => {
      const first = row.firstElementChild;
      return first ? first.getBoundingClientRect().width + 12 : 200;
    };
    this.querySelector('[data-xel-recs-prev]')?.addEventListener('click', () => row.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    this.querySelector('[data-xel-recs-next]')?.addEventListener('click', () => row.scrollBy({ left: step() * 2, behavior: 'smooth' }));
  }
}
if (!customElements.get('xelara-cart-recommendations')) customElements.define('xelara-cart-recommendations', XelaraCartRecommendations);

class XelaraCartDiscount extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-xel-discount-form]');
    this.error = this.querySelector('[data-xel-discount-error]');
    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const code = this.form.querySelector('input[name="discount"]').value.trim();
      if (!code) return;
      const existing = this.codes();
      if (!existing.includes(code)) existing.push(code);
      this.apply(existing, code);
    });
    this.querySelectorAll('[data-xel-discount-remove]').forEach((btn) =>
      btn.addEventListener('click', () => {
        const code = btn.closest('[data-code]')?.dataset.code;
        this.apply(this.codes().filter((c) => c !== code));
      })
    );
  }

  codes() {
    return [...this.querySelectorAll('[data-code]')].map((li) => li.dataset.code);
  }

  async apply(codes, justAdded) {
    this.classList.add('is-busy');
    if (this.error) this.error.hidden = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer' }),
      });
      const data = await res.json();
      const bad = justAdded && (data.discount_codes || []).find((c) => c.code.toLowerCase() === justAdded.toLowerCase() && !c.applicable);
      if (bad) {
        // Drop the invalid code again and show the message once the drawer re-renders.
        const keep = codes.filter((c) => c !== justAdded);
        const res2 = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: keep.join(','), sections: 'cart-drawer' }),
        });
        const data2 = await res2.json();
        rerenderDrawer(data2.sections['cart-drawer']);
        const err = document.querySelector('cart-drawer [data-xel-discount-error]');
        if (err) {
          err.hidden = false;
          err.closest('details')?.setAttribute('open', '');
        }
        return;
      }
      rerenderDrawer(data.sections['cart-drawer']);
    } catch (e) {
      console.error(e);
    } finally {
      this.classList.remove('is-busy');
    }
  }
}
if (!customElements.get('xelara-cart-discount')) customElements.define('xelara-cart-discount', XelaraCartDiscount);
